import { AdenaValue } from "../item/Adena";
import { Icon24 } from "../ui/Icon";
import css from "./Market.module.css";
import { useState } from "react";

type Item = {
  id: number;
  itemName: string;
  name: string;
  icon: string;
};

type Store = {
  name: string;
  loc: string;
  price: number;
  count: number;
};

type Data = {
  item: Item;
  sellers: Store[];
  buyers: Store[];
};

export function Market(params: { data: Data[]; height?: number }) {
  const { data, height } = params;
  const [selected, setSelected] = useState<Data | null>();

  function handleClick(itemId: number) {
    const item = data.find((f) => f.item.id === itemId);
    setSelected(item);
  }

  return (
    <div className="columns">
      <div className="column">
        <List
          data={data}
          onClick={(itemId) => handleClick(itemId)}
          height={height}
        />
      </div>
      <div className="column">
        <div className={css.storeList}>
          <div className={css.title}>Buyers</div>
          <ul style={{ height: height && height + 28 }}>
            {selected
              ? selected.buyers.map((b, i) => (
                  <PrivateStore key={i} store={b} type="buy" />
                ))
              : null}
          </ul>
        </div>
      </div>
      <div className="column">
        <div className={css.storeList}>
          <div className={css.title}>Sellers</div>
          <ul style={{ height: height && height + 28 }}>
            {selected
              ? selected.sellers.map((s, i) => (
                  <PrivateStore store={s} type="sell" />
                ))
              : null}
          </ul>
        </div>
      </div>
    </div>
  );
}

function List(params: {
  data: Data[];
  height?: number | string;
  onClick: (itemId: number) => void;
}) {
  const { data, height } = params;
  const [filter, setFilter] = useState("");

  function handleClick(itemId: number) {
    params.onClick(itemId);
  }
  return (
    <div className={css.explorer}>
      <div className={css.title}>Items</div>
      <input
        className={css.input}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        autoComplete="off"
        placeholder="Search Item"
      />
      <ul style={{ height: height ?? 400 }}>
        {data
          .filter(
            (f) =>
              f.item.name
                .toLocaleLowerCase()
                .includes(filter.toLocaleLowerCase()) || filter === ""
          )
          .map((item, i) => (
            <Item key={i} data={item} onClick={handleClick} />
          ))}
      </ul>
    </div>
  );
}

function Item(params: {
  data: { item: Item };
  onClick: (itemId: number) => void;
}) {
  const { item } = params.data;

  function handleClick(itemId: number) {
    params.onClick(itemId);
  }
  return item ? (
    <li className={css.item} onClick={() => handleClick(item.id)}>
      <Icon24 icon={item.icon} />
      <div className={css.itemName}>
        <span>{item.name}</span>
      </div>
    </li>
  ) : (
    <div>juy</div>
  );
}

function PrivateStore(params: {
  store: { name: string; price: number; loc: string; count: number };
  type: "buy" | "sell";
}) {
  const { store, type } = params;
  return (
    <li className={css.privateStore}>
      <div>
        <div
          className={css.name}
          style={{ color: type === "buy" ? "#fdfaa5" : "#eaa2f5" }}
        >
          {store.name}
        </div>
        <div className={css.loc}>{store.loc}</div>
      </div>
      <div style={{ textAlign: "right" }}>
        <div>
          <AdenaValue value={store.price} />
        </div>
        <div style={{ fontSize: 12 }}>x{store.count}</div>
      </div>
    </li>
  );
}
